import { NSARouterMakerResult } from 'namirasoft-account-react';
import { CacheService, EnvService, IStorageLocal } from 'namirasoft-core';
import { NamirasoftPasswordServer, UserFullRow } from 'namirasoft-password';
import { NSLoading } from 'namirasoft-site-react';
import { useEffect, useState } from 'react';
import { PasswordName } from './PasswordName';

export interface SetupLayoutProps extends NSARouterMakerResult
{
    children: {
        onSetupRequired: (loadUser: () => Promise<void>) => JSX.Element;
        onSetupAvailable: (loadUser: () => Promise<void>, user: UserFullRow) => JSX.Element;
    }
}

export interface SetupLayoutState
{
    loading: boolean;
    user: UserFullRow | null;
}

function SetupLayout(props: SetupLayoutProps)
{
    let [state, setState] = useState<SetupLayoutState>({ loading: true, user: null });

    const loadUser = async () =>
    {
        let user_id = props.account.token_manager.getUserData(u => u.id, "");
        let storage = new IStorageLocal();

        let cache = new CacheService<UserFullRow | null>(
            PasswordName.storage.USER(user_id),
            storage,
            24 * 60 * 60,
            async () => "1.0.0",
            async () =>
            {
                let REACT_APP_BASE_URL_PASSWORD = new EnvService("REACT_APP_BASE_URL_PASSWORD", true).getString();
                let password_server = new NamirasoftPasswordServer(REACT_APP_BASE_URL_PASSWORD, props.account.token_manager, props.notifier.onError);
                try
                {
                    return await password_server.user.Get({ onError: () => { } });
                }
                catch (error)
                {
                    return null;
                }
            }
        );

        let user = await cache.get()
        setState(() => ({ user, loading: false }));
    }

    useEffect(() =>
    {
        loadUser();
        // eslint-disable-next-line
    }, []);

    if (state.loading)
        return <NSLoading />;
    if (state.user === null)
        return props.children.onSetupRequired(loadUser);
    return props.children.onSetupAvailable(loadUser, state.user);
}

export default SetupLayout;